import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { qnaKey } from './queryKeys';

export const useQnaMutation = (resource, id, mutationFn, { successMessage, onSuccess } = {}) => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: qnaKey(resource, id) });
      const message =
        typeof successMessage === 'function' ? successMessage(variables) : successMessage;
      if (message) {
        enqueueSnackbar(message, { variant: 'success' });
      }
      onSuccess?.(data, variables);
    },
    onError: (error) => {
      enqueueSnackbar(
        error?.response?.data?.description || error?.message || 'Some error occured',
        {
          variant: 'error',
        }
      );
    },
  });
};
